/* Diamond Education JavaScript for Shopify */
/* Add this script to your theme or include it on the page */

(function() {
  'use strict';

  // ============================================
  // DATA
  // ============================================

  const cutGradeData = [
    {
      grade: 'Ideal / Excellent',
      cutType: 'ideal',
      shortDesc: 'Maximum brilliance and fire',
      description: 'The highest cut grades, representing the top 3-15% of diamonds. Light enters and reflects back through the top with maximum brilliance, fire, and scintillation. Every facet is precisely aligned for optimal light performance.',
      characteristics: ['Maximum light return', 'Perfect symmetry', 'Optimal proportions', 'Exceptional fire and brilliance'],
      buyingTip: 'Ideal and Excellent cut diamonds command premium prices but offer unparalleled sparkle. Best choice for engagement rings where brilliance matters most.',
      priceImpact: 'Premium: Highest price point for cut quality',
      proportionLabel: 'IDEAL',
      lightLabel: 'OPTIMAL',
    },
    {
      grade: 'Very Good',
      cutType: 'ideal',
      shortDesc: 'Superior brilliance at better value',
      description: 'High-quality cut with most light reflecting through the top. Minor proportion variations may direct some light through the sides. Still produces significant brilliance and fire visible to the eye.',
      characteristics: ['Strong light return', 'Good symmetry', 'Slight proportion variance', 'Notable brilliance'],
      buyingTip: 'Very Good cut diamonds offer excellent value, allowing you to prioritize carat weight or clarity while maintaining strong visual appeal.',
      priceImpact: 'Moderate: 10-15% below Excellent',
      proportionLabel: 'GOOD',
      lightLabel: 'GOOD RETURN',
    },
    {
      grade: 'Good',
      cutType: 'shallow',
      shortDesc: 'Adequate light performance',
      description: 'Acceptable cut quality where noticeable light escapes through the sides or bottom. The diamond will still sparkle but with less intensity than higher grades. Represents value-conscious choices.',
      characteristics: ['Moderate light return', 'Acceptable symmetry', 'Visible proportion variance', 'Reduced brilliance'],
      buyingTip: 'Good cut is suitable for side stones or when maximizing carat weight on a budget. Consider upgrading for center stones.',
      priceImpact: 'Value: 20-30% below Excellent',
      proportionLabel: 'TOO SHALLOW',
      lightLabel: 'LIGHT LEAKS',
    },
    {
      grade: 'Fair',
      cutType: 'deep',
      shortDesc: 'Minimal brilliance',
      description: 'Below-average cut where significant light escapes through the sides, resulting in a noticeably less brilliant appearance. The diamond may appear dull or lifeless compared to better-cut stones.',
      characteristics: ['Poor light return', 'Visible asymmetry', 'Poor proportions', 'Diminished sparkle'],
      buyingTip: 'Fair cut diamonds are generally not recommended for visible jewelry. The savings rarely justify the lack of brilliance.',
      priceImpact: 'Budget: 40-50% below Excellent',
      proportionLabel: 'TOO DEEP',
      lightLabel: 'LIGHT LEAKS',
    },
    {
      grade: 'Poor',
      cutType: 'deep',
      shortDesc: 'Significant light loss',
      description: 'The lowest cut grade where most light escapes through the bottom or sides. These diamonds lack sparkle and appear dull even in good lighting conditions.',
      characteristics: ['Minimal light return', 'Obvious asymmetry', 'Very poor proportions', 'Little to no sparkle'],
      buyingTip: 'Poor cut diamonds should be avoided for any jewelry where appearance matters. The price savings do not compensate for the lack of beauty.',
      priceImpact: 'Lowest: 50-60% below Excellent',
      proportionLabel: 'POOR',
      lightLabel: 'POOR RETURN',
    },
  ];

  const colorGradeData = [
    { grade: 'D', category: 'Colorless', shortDesc: 'Absolutely colorless', description: 'The highest color grade, completely devoid of any color. Extremely rare and highly prized.', characteristics: ['Pure ice-white appearance', 'Maximum light transmission', 'Rarest color grade', 'Museum quality'], buyingTip: 'D color is for collectors and those who want absolute perfection. Most people cannot distinguish D from E or F.', priceImpact: 'Ultra Premium: Highest price point' },
    { grade: 'E', category: 'Colorless', shortDesc: 'Virtually colorless', description: 'Minute traces of color detectable only by expert gemologists under controlled conditions.', characteristics: ['Near-perfect colorlessness', 'Excellent light transmission', 'Very rare', 'Investment grade'], buyingTip: 'E color offers nearly identical appearance to D at a lower price. Excellent choice for platinum or white gold settings.', priceImpact: 'Premium: 5-10% below D' },
    { grade: 'F', category: 'Colorless', shortDesc: 'Colorless to experts', description: 'Minor color detectable by expert gemologists when compared side-by-side with higher grades.', characteristics: ['Colorless appearance', 'Excellent value in colorless range', 'Face-up colorless', 'High quality'], buyingTip: 'F color is the sweet spot of the colorless range—exceptional appearance with better value than D-E.', priceImpact: 'Premium: 10-15% below D' },
    { grade: 'G', category: 'Near Colorless', shortDesc: 'Near colorless', description: 'First grade of "near colorless" range. Color difficult to detect unless compared directly to colorless grades.', characteristics: ['Face-up appears colorless', 'Slight warmth from side view', 'Excellent value', 'Popular choice'], buyingTip: 'G color is the most popular choice for engagement rings—appears colorless when mounted with significant savings.', priceImpact: 'Value: 15-20% below D' },
    { grade: 'H', category: 'Near Colorless', shortDesc: 'Near colorless with slight warmth', description: 'Slight color visible when compared to higher grades. Still appears predominantly white, especially when set in yellow or rose gold.', characteristics: ['Slight warmth visible', 'White face-up appearance', 'Great for warm metals', 'Strong value'], buyingTip: 'H color pairs beautifully with yellow or rose gold settings. The warm metal complements any slight tint.', priceImpact: 'Value: 25-30% below D' },
    { grade: 'I', category: 'Near Colorless', shortDesc: 'Slightly detectable color', description: 'Color more easily detected, appearing as a slight yellow or brown tint. Best suited for yellow gold settings.', characteristics: ['Noticeable warmth', 'Budget-friendly', 'Best in warm settings', 'Visible tint'], buyingTip: 'I color offers maximum carat weight for budget. Choose yellow gold settings to complement the warm tones.', priceImpact: 'Budget: 35-40% below D' },
    { grade: 'J', category: 'Near Colorless', shortDesc: 'Visible warmth', description: 'Last grade of near colorless range. Yellow or brown tint visible to the naked eye, especially in larger stones.', characteristics: ['Visible yellow/brown tint', 'Warm appearance', 'Significant savings', 'Complement warm metals'], buyingTip: 'J color works well for vintage-style settings or when embracing a warmer aesthetic.', priceImpact: 'Budget: 40-50% below D' },
  ];

  const clarityGradeData = [
    { grade: 'FL', fullName: 'Flawless', shortDesc: 'No inclusions or blemishes', description: 'The highest clarity grade. No inclusions or blemishes visible under 10x magnification. Extremely rare.', characteristics: ['Completely clean', 'Extremely rare', 'Collector grade', 'Perfect transparency'], buyingTip: 'FL diamonds are for collectors and investors. The perfection is undetectable to the naked eye compared to lower grades.', priceImpact: 'Ultra Premium: Highest clarity price', inclusionCount: 0 },
    { grade: 'IF', fullName: 'Internally Flawless', shortDesc: 'No internal inclusions', description: 'No inclusions visible under 10x magnification, only insignificant surface blemishes.', characteristics: ['Internally perfect', 'Minor surface marks only', 'Very rare', 'Near-perfect transparency'], buyingTip: 'IF offers the appearance of perfection at a slight discount from FL.', priceImpact: 'Premium: 5-10% below FL', inclusionCount: 0 },
    { grade: 'VVS1', fullName: 'Very Very Slightly Included 1', shortDesc: 'Minute inclusions, extremely difficult to see', description: 'Inclusions so small they are extremely difficult for a skilled grader to detect under 10x magnification.', characteristics: ['Extremely minor inclusions', 'Difficult for experts to find', 'Eye-clean always', 'Excellent transparency'], buyingTip: 'VVS1 is the practical ceiling for most buyers—any higher provides no visible benefit.', priceImpact: 'Premium: 15-20% below FL', inclusionCount: 1 },
    { grade: 'VVS2', fullName: 'Very Very Slightly Included 2', shortDesc: 'Minute inclusions, very difficult to see', description: 'Slightly more visible inclusions than VVS1, but still very difficult to detect under 10x magnification.', characteristics: ['Very minor inclusions', 'Hard for experts to find', 'Always eye-clean', 'Excellent transparency'], buyingTip: 'VVS2 offers excellent clarity with better value. Perfect for those who want assurance of eye-cleanliness.', priceImpact: 'Premium: 20-25% below FL', inclusionCount: 2 },
    { grade: 'VS1', fullName: 'Very Slightly Included 1', shortDesc: 'Minor inclusions, difficult to see', description: 'Minor inclusions observed with effort under 10x magnification. Inclusions are typically small crystals or clouds.', characteristics: ['Minor inclusions', 'Found with effort under 10x', 'Eye-clean', 'Very good transparency'], buyingTip: 'VS1 is the sweet spot for many buyers—guaranteed eye-clean with significant savings versus VVS grades.', priceImpact: 'Value: 30-35% below FL', inclusionCount: 3 },
    { grade: 'VS2', fullName: 'Very Slightly Included 2', shortDesc: 'Minor inclusions, somewhat easy to see', description: 'Minor inclusions somewhat easily observed under 10x magnification. Usually eye-clean.', characteristics: ['Noticeable under magnification', 'Usually eye-clean', 'Good transparency', 'Excellent value'], buyingTip: 'VS2 offers the best balance of clarity and value for most engagement rings.', priceImpact: 'Value: 35-40% below FL', inclusionCount: 4 },
    { grade: 'SI1', fullName: 'Slightly Included 1', shortDesc: 'Noticeable inclusions under magnification', description: 'Inclusions noticeable under 10x magnification. May or may not be eye-clean depending on inclusion type and location.', characteristics: ['Visible under 10x', 'May be eye-clean', 'Depends on inclusion placement', 'Good value'], buyingTip: 'SI1 can offer exceptional value if inclusions are white or positioned under the bezel.', priceImpact: 'Budget: 45-50% below FL', inclusionCount: 6 },
    { grade: 'SI2', fullName: 'Slightly Included 2', shortDesc: 'Inclusions easily visible under magnification', description: 'Inclusions easily visible under 10x magnification and may be visible to the naked eye.', characteristics: ['Easily found under 10x', 'Often visible to naked eye', 'Inclusions may affect appearance', 'Budget option'], buyingTip: 'SI2 requires careful selection. Look for stones where inclusions are off-center or white.', priceImpact: 'Budget: 50-55% below FL', inclusionCount: 8 },
    { grade: 'I1', fullName: 'Included 1', shortDesc: 'Obvious inclusions affecting appearance', description: 'Inclusions obvious under 10x magnification and visible to the naked eye. May affect transparency and brilliance.', characteristics: ['Visible to naked eye', 'Affects brilliance', 'May impact durability', 'Significant inclusions'], buyingTip: 'I1 diamonds are generally not recommended for engagement rings.', priceImpact: 'Low: 60-70% below FL', inclusionCount: 12 },
  ];

  const caratData = [
    { carat: 0.25, diameter: 4.1, description: 'Delicate accent size', popular: false },
    { carat: 0.50, diameter: 5.1, description: 'Classic petite', popular: true },
    { carat: 0.75, diameter: 5.8, description: 'Elegant understated', popular: false },
    { carat: 1.00, diameter: 6.4, description: 'Most popular choice', popular: true },
    { carat: 1.25, diameter: 6.9, description: 'Noticeable presence', popular: false },
    { carat: 1.50, diameter: 7.3, description: 'Statement size', popular: true },
    { carat: 2.00, diameter: 8.1, description: 'Impressive display', popular: true },
    { carat: 2.50, diameter: 8.8, description: 'Luxury statement', popular: false },
    { carat: 3.00, diameter: 9.3, description: 'Exceptional rarity', popular: false },
  ];

  const specsData = {
    fluorescence: {
      title: 'Fluorescence',
      description: 'The visible light some diamonds emit when exposed to UV rays. About 25-35% of diamonds exhibit some degree of fluorescence.',
      grades: [
        { grade: 'None', desc: 'No fluorescence visible under UV light', impact: 'Neutral to premium pricing' },
        { grade: 'Faint', desc: 'Barely detectable glow under UV', impact: 'Neutral pricing' },
        { grade: 'Medium', desc: 'Noticeable blue glow under UV', impact: 'May improve perceived color in lower grades' },
        { grade: 'Strong', desc: 'Obvious fluorescence visible in daylight', impact: '10-15% discount typical' },
        { grade: 'Very Strong', desc: 'Intense glow, may appear hazy', impact: '15-30% discount, may affect appearance' },
      ],
      tip: 'Medium blue fluorescence can make H-J color diamonds appear whiter, offering hidden value.'
    },
    polish: {
      title: 'Polish',
      description: 'The smoothness of the diamond\'s surface as a result of the polishing process. Affects light entry and return.',
      grades: [
        { grade: 'Excellent', desc: 'No polish defects visible at 10x', impact: 'Maximum brilliance' },
        { grade: 'Very Good', desc: 'Minor defects difficult to see at 10x', impact: 'Negligible effect on brilliance' },
        { grade: 'Good', desc: 'Defects visible at 10x, not naked eye', impact: 'Slight impact on light performance' },
        { grade: 'Fair', desc: 'Defects may be visible to naked eye', impact: 'Noticeable dulling of brilliance' },
        { grade: 'Poor', desc: 'Obvious defects affecting appearance', impact: 'Significant loss of brilliance' },
      ],
      tip: 'Always choose Excellent or Very Good polish—the price difference is minimal but the impact on brilliance is real.'
    },
    symmetry: {
      title: 'Symmetry',
      description: 'How precisely the facets align and mirror each other. Affects how light travels through and exits the diamond.',
      grades: [
        { grade: 'Excellent', desc: 'Perfect facet alignment and proportions', impact: 'Optimal light performance' },
        { grade: 'Very Good', desc: 'Minor deviations not affecting appearance', impact: 'Near-optimal brilliance' },
        { grade: 'Good', desc: 'Noticeable deviations under magnification', impact: 'Slight light leakage' },
        { grade: 'Fair', desc: 'Visible asymmetry affecting light return', impact: 'Reduced brilliance' },
        { grade: 'Poor', desc: 'Obvious misalignment of facets', impact: 'Significant brilliance loss' },
      ],
      tip: 'For round brilliants, prioritize Excellent symmetry. Fancy shapes are more forgiving of Very Good grades.'
    }
  };

  // ============================================
  // SVG GENERATORS
  // ============================================

  function createProportionsSVG(cutType) {
    const proportions = {
      shallow: { crownHeight: 8, pavilionDepth: 28, tableWidth: 65 },
      ideal: { crownHeight: 14, pavilionDepth: 42, tableWidth: 56 },
      deep: { crownHeight: 18, pavilionDepth: 52, tableWidth: 48 }
    };

    const { crownHeight, pavilionDepth, tableWidth } = proportions[cutType] || proportions.ideal;
    const cx = 70, girdleY = 30, totalWidth = 100, halfWidth = totalWidth / 2;
    const halfTable = tableWidth / 2;
    const tableLeft = cx - halfTable, tableRight = cx + halfTable;
    const crownLeft = cx - halfWidth, crownRight = cx + halfWidth;
    const culetY = girdleY + pavilionDepth, tableY = girdleY - crownHeight;

    return `<svg width="140" height="98" viewBox="0 0 140 98">
      <g fill="none" stroke="#2D2D2D" stroke-width="1.5" stroke-linejoin="round">
        <polygon points="${tableLeft},${tableY} ${tableRight},${tableY} ${crownRight},${girdleY} ${crownLeft},${girdleY}"/>
        <line x1="${tableLeft}" y1="${tableY}" x2="${tableRight}" y2="${tableY}"/>
        <line x1="${tableLeft}" y1="${tableY}" x2="${crownLeft}" y2="${girdleY}"/>
        <line x1="${tableRight}" y1="${tableY}" x2="${crownRight}" y2="${girdleY}"/>
        <line x1="${cx}" y1="${tableY}" x2="${cx - halfWidth * 0.5}" y2="${girdleY}"/>
        <line x1="${cx}" y1="${tableY}" x2="${cx + halfWidth * 0.5}" y2="${girdleY}"/>
        <polygon points="${crownLeft},${girdleY} ${crownRight},${girdleY} ${cx},${culetY}"/>
        <line x1="${cx - halfWidth * 0.5}" y1="${girdleY}" x2="${cx}" y2="${culetY}"/>
        <line x1="${cx + halfWidth * 0.5}" y1="${girdleY}" x2="${cx}" y2="${culetY}"/>
      </g>
    </svg>`;
  }

  function createLightReturnSVG(cutType) {
    const proportions = {
      shallow: { crownHeight: 8, pavilionDepth: 28, tableWidth: 65 },
      ideal: { crownHeight: 14, pavilionDepth: 42, tableWidth: 56 },
      deep: { crownHeight: 18, pavilionDepth: 52, tableWidth: 48 }
    };

    const { crownHeight, pavilionDepth, tableWidth } = proportions[cutType] || proportions.ideal;
    const cx = 70, girdleY = 30, totalWidth = 100, halfWidth = totalWidth / 2;
    const halfTable = tableWidth / 2;
    const crownLeft = cx - halfWidth, crownRight = cx + halfWidth;
    const culetY = girdleY + pavilionDepth, tableY = girdleY - crownHeight;
    const markerId = `arrow-${cutType}-${Date.now()}`;

    let lightPaths = '';
    if (cutType === 'ideal') {
      lightPaths = `
        <line x1="${cx - 10}" y1="${tableY - 20}" x2="${cx - 10}" y2="${tableY + 8}"/>
        <line x1="${cx + 10}" y1="${tableY - 20}" x2="${cx + 10}" y2="${tableY + 8}"/>
        <path d="M${cx - 10} ${tableY + 8} L${cx + 20} ${girdleY + pavilionDepth * 0.6} L${cx - 5} ${tableY + 5}"/>
        <path d="M${cx + 10} ${tableY + 8} L${cx - 20} ${girdleY + pavilionDepth * 0.6} L${cx + 5} ${tableY + 5}"/>
        <line x1="${cx - 5}" y1="${tableY + 5}" x2="${cx - 8}" y2="${tableY - 12}" marker-end="url(#${markerId})"/>
        <line x1="${cx + 5}" y1="${tableY + 5}" x2="${cx + 8}" y2="${tableY - 12}" marker-end="url(#${markerId})"/>
      `;
    } else if (cutType === 'shallow') {
      lightPaths = `
        <line x1="${cx}" y1="${tableY - 20}" x2="${cx}" y2="${tableY + 8}"/>
        <line x1="${cx}" y1="${tableY + 8}" x2="${cx + 15}" y2="${girdleY + pavilionDepth * 0.5}"/>
        <line x1="${cx + 15}" y1="${girdleY + pavilionDepth * 0.5}" x2="${cx + 20}" y2="${culetY + 15}" marker-end="url(#${markerId})"/>
      `;
    } else {
      lightPaths = `
        <line x1="${cx}" y1="${tableY - 20}" x2="${cx}" y2="${tableY + 8}"/>
        <line x1="${cx}" y1="${tableY + 8}" x2="${cx - 15}" y2="${girdleY + pavilionDepth * 0.4}"/>
        <line x1="${cx - 15}" y1="${girdleY + pavilionDepth * 0.4}" x2="${cx - 55}" y2="${girdleY + 5}" marker-end="url(#${markerId})"/>
      `;
    }

    return `<svg width="140" height="119" viewBox="0 0 140 119">
      <defs>
        <marker id="${markerId}" markerWidth="8" markerHeight="8" refX="4" refY="4" orient="auto">
          <path d="M0,0 L8,4 L0,8 Z" fill="#DDA15E"/>
        </marker>
      </defs>
      <g fill="none" stroke="#2D2D2D" stroke-width="1" opacity="0.4" stroke-linejoin="round">
        <polygon points="${cx - halfTable},${tableY} ${cx + halfTable},${tableY} ${crownRight},${girdleY} ${crownLeft},${girdleY}"/>
        <polygon points="${crownLeft},${girdleY} ${crownRight},${girdleY} ${cx},${culetY}"/>
      </g>
      <g stroke="#DDA15E" stroke-width="2" fill="none">
        ${lightPaths}
      </g>
    </svg>`;
  }

  function createColorDiamondSVG(colorIndex, size, isSelected) {
    const colors = ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFEF5', '#FFFCE8', '#FFF8D6', '#FFF4C4'];
    const fill = colors[Math.min(colorIndex, colors.length - 1)];
    const stroke = isSelected ? '#DDA15E' : '#2D2D2D';
    const strokeWidth = isSelected ? 2 : 1.5;

    return `<svg width="${size}" height="${size}" viewBox="0 0 120 95">
      <polygon points="32,15 88,15 108,30 60,78 12,30" fill="${fill}" stroke="${stroke}" stroke-width="${strokeWidth}" stroke-linejoin="round"/>
      <g stroke="${stroke}" stroke-width="1" fill="none">
        <line x1="32" y1="15" x2="12" y2="30"/>
        <line x1="88" y1="15" x2="108" y2="30"/>
        <line x1="60" y1="15" x2="36" y2="30"/>
        <line x1="60" y1="15" x2="84" y2="30"/>
        <line x1="36" y1="30" x2="60" y2="78"/>
        <line x1="84" y1="30" x2="60" y2="78"/>
      </g>
    </svg>`;
  }

  function createClarityDiamondSVG(inclusionCount, size, isSelected) {
    const stroke = isSelected ? '#666633' : '#2D2D2D';
    const strokeWidth = isSelected ? 1.5 : 1;
    const cx = 70, cy = 70, outerR = 58, tableR = 24;

    // Generate facet pattern
    let facets = '';
    for (let i = 0; i < 8; i++) {
      const angle = (i * Math.PI * 2) / 8 - Math.PI / 2;
      const midAngle = angle + Math.PI / 8;
      const cos = Math.cos(angle), sin = Math.sin(angle);
      const midCos = Math.cos(midAngle), midSin = Math.sin(midAngle);

      facets += `<line x1="${cx + cos * tableR}" y1="${cy + sin * tableR}" x2="${cx + midCos * tableR * 1.5}" y2="${cy + midSin * tableR * 1.5}"/>`;
      facets += `<line x1="${cx + midCos * tableR * 1.5}" y1="${cy + midSin * tableR * 1.5}" x2="${cx + cos * outerR * 0.78}" y2="${cy + sin * outerR * 0.78}"/>`;
      facets += `<line x1="${cx + cos * outerR * 0.78}" y1="${cy + sin * outerR * 0.78}" x2="${cx + cos * outerR}" y2="${cy + sin * outerR}"/>`;
    }

    // Generate inclusions
    let inclusions = '';
    for (let i = 0; i < Math.min(inclusionCount, 12); i++) {
      const angle = (i * 2.39996) + (i * 0.7);
      const r = tableR * 0.5 + ((i * 11) % (outerR * 0.6 - tableR * 0.5));
      const x = cx + Math.cos(angle) * r;
      const y = cy + Math.sin(angle) * r;
      const incSize = 2 + (i % 3) * 1.5;
      inclusions += `<circle cx="${x}" cy="${y}" r="${incSize}" fill="#2D2D2D" fill-opacity="0.4"/>`;
    }

    // Table octagon points
    let tablePoints = '';
    for (let i = 0; i < 8; i++) {
      const angle = (i * Math.PI * 2) / 8 - Math.PI / 2;
      tablePoints += `${cx + Math.cos(angle) * tableR},${cy + Math.sin(angle) * tableR} `;
    }

    return `<svg width="${size}" height="${size}" viewBox="0 0 140 140">
      <circle cx="${cx}" cy="${cy}" r="${outerR}" fill="none" stroke="${stroke}" stroke-width="${strokeWidth * 1.5}"/>
      <g stroke="${stroke}" stroke-width="${strokeWidth}" fill="none">
        <polygon points="${tablePoints.trim()}"/>
        ${facets}
      </g>
      ${inclusions}
    </svg>`;
  }

  function createCaratDiamondSVG(size, isSelected) {
    const stroke = isSelected ? '#DDA15E' : '#2D2D2D';
    const strokeWidth = isSelected ? 1.2 : 0.8;
    const fill = isSelected ? '#FFF8F0' : '#FAFAFA';
    const cx = 50, cy = 50, outerR = 46, tableR = 18, starR = 26, bezelR = 38;

    let svg = `<svg width="${size}" height="${size}" viewBox="0 0 100 100">
      <circle cx="${cx}" cy="${cy}" r="${outerR}" fill="${fill}"/>
      <circle cx="${cx}" cy="${cy}" r="${outerR}" fill="none" stroke="${stroke}" stroke-width="${strokeWidth * 1.5}"/>
      <g stroke="${stroke}" stroke-width="${strokeWidth}" fill="none">`;

    // Table octagon
    let tablePoints = '';
    const mainAngles = [], midAngles = [];
    for (let i = 0; i < 8; i++) {
      const angle = (i * Math.PI * 2) / 8 - Math.PI / 2;
      mainAngles.push(angle);
      midAngles.push(angle + Math.PI / 8);
      tablePoints += `${cx + Math.cos(angle) * tableR},${cy + Math.sin(angle) * tableR} `;
    }
    svg += `<polygon points="${tablePoints.trim()}" stroke-width="${strokeWidth * 1.2}"/>`;

    // Star and bezel facets
    for (let i = 0; i < 8; i++) {
      const ma = mainAngles[i], mida = midAngles[i];
      const nextMa = mainAngles[(i + 1) % 8];

      // Star facets
      svg += `<line x1="${cx + Math.cos(ma) * tableR}" y1="${cy + Math.sin(ma) * tableR}" x2="${cx + Math.cos(mida) * starR}" y2="${cy + Math.sin(mida) * starR}"/>`;
      svg += `<line x1="${cx + Math.cos(mida) * starR}" y1="${cy + Math.sin(mida) * starR}" x2="${cx + Math.cos(nextMa) * tableR}" y2="${cy + Math.sin(nextMa) * tableR}"/>`;

      // Bezel facets
      svg += `<line x1="${cx + Math.cos(mida) * starR}" y1="${cy + Math.sin(mida) * starR}" x2="${cx + Math.cos(ma) * bezelR}" y2="${cy + Math.sin(ma) * bezelR}"/>`;
      svg += `<line x1="${cx + Math.cos(mida) * starR}" y1="${cy + Math.sin(mida) * starR}" x2="${cx + Math.cos(nextMa) * bezelR}" y2="${cy + Math.sin(nextMa) * bezelR}"/>`;

      // Girdle facets
      const gp1Angle = (i * 2 * Math.PI) / 16 - Math.PI / 2;
      const gp2Angle = ((i * 2 + 1) * Math.PI) / 8 - Math.PI / 2;
      svg += `<line x1="${cx + Math.cos(ma) * bezelR}" y1="${cy + Math.sin(ma) * bezelR}" x2="${cx + Math.cos(gp1Angle) * outerR}" y2="${cy + Math.sin(gp1Angle) * outerR}"/>`;
    }

    svg += `</g></svg>`;
    return svg;
  }

  // ============================================
  // RENDER FUNCTIONS
  // ============================================

  function renderCutDetails(index) {
    const data = cutGradeData[index];
    const isIdeal = index === 0;

    document.getElementById('cut-proportions-visual').innerHTML = createProportionsSVG(data.cutType);
    document.getElementById('cut-proportions-visual').className = 'de-visual-content' + (isIdeal ? ' highlight' : '');
    document.getElementById('cut-proportions-label').textContent = data.proportionLabel;
    document.getElementById('cut-proportions-label').className = 'de-visual-label' + (isIdeal ? ' highlight' : '');

    document.getElementById('cut-light-visual').innerHTML = createLightReturnSVG(data.cutType);
    document.getElementById('cut-light-visual').className = 'de-visual-content' + (isIdeal ? ' highlight' : '');
    document.getElementById('cut-light-label').textContent = data.lightLabel;
    document.getElementById('cut-light-label').className = 'de-visual-label' + (isIdeal ? ' highlight' : '');

    document.getElementById('cut-details').innerHTML = `
      <h3 class="de-details-title">${data.grade}</h3>
      <p class="de-details-subtitle">${data.shortDesc}</p>
      <p class="de-details-description">${data.description}</p>
      <div class="de-characteristics">
        ${data.characteristics.map(c => `<div class="de-characteristic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg><span>${c}</span></div>`).join('')}
      </div>
      <div class="de-tip-box">
        <div class="de-tip-box-content">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
          <div><strong>Buying Tip: </strong><span>${data.buyingTip}</span></div>
        </div>
      </div>
      <div class="de-price-impact">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v18M5 8l7-5 7 5M5 16l7 5 7-5"/></svg>
        <span class="label">Price Impact:</span>
        <span class="value">${data.priceImpact}</span>
      </div>
    `;
  }

  function renderColorSection(selectedIndex) {
    const scale = document.getElementById('color-scale');
    scale.innerHTML = colorGradeData.map((g, i) => {
      const size = i === selectedIndex ? 90 : 75;
      return `<div class="de-color-diamond ${i === selectedIndex ? 'selected' : ''}" data-index="${i}">
        ${createColorDiamondSVG(i, size, i === selectedIndex)}
        <span class="grade-label">${g.grade}</span>
      </div>`;
    }).join('');

    // Update category highlights
    document.querySelectorAll('.de-color-cat').forEach(cat => {
      const range = cat.dataset.range;
      let isActive = false;
      if (range.includes('-')) {
        const [min, max] = range.split('-').map(Number);
        isActive = selectedIndex >= min && selectedIndex <= max;
      } else {
        isActive = selectedIndex === parseInt(range);
      }
      cat.classList.toggle('active', isActive);
    });

    const data = colorGradeData[selectedIndex];
    document.getElementById('color-details').innerHTML = `
      <div class="de-details-header">
        <h3 class="de-details-title">${data.grade}</h3>
        <span style="font-size: 1.125rem; color: var(--de-stone-500);">${data.category}</span>
      </div>
      <p class="de-details-subtitle">${data.shortDesc}</p>
      <p class="de-details-description">${data.description}</p>
      <div class="de-characteristics">
        ${data.characteristics.map(c => `<div class="de-characteristic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg><span>${c}</span></div>`).join('')}
      </div>
      <div class="de-tip-box">
        <div class="de-tip-box-content">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
          <div><strong>Buying Tip: </strong><span>${data.buyingTip}</span></div>
        </div>
      </div>
      <div class="de-price-impact">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v18M5 8l7-5 7 5M5 16l7 5 7-5"/></svg>
        <span class="label">Price Impact:</span>
        <span class="value">${data.priceImpact}</span>
      </div>
    `;
  }

  function renderClaritySection(selectedIndex) {
    const scale = document.getElementById('clarity-scale');
    scale.innerHTML = clarityGradeData.map((g, i) => {
      const size = i === selectedIndex ? 100 : 85;
      return `<div class="de-clarity-diamond ${i === selectedIndex ? 'selected' : ''}" data-index="${i}">
        <div class="diamond-wrapper">${createClarityDiamondSVG(g.inclusionCount, size, i === selectedIndex)}</div>
        <span class="grade-label">${g.grade}</span>
      </div>`;
    }).join('');

    // Update category highlights
    document.querySelectorAll('.de-clarity-cat').forEach(cat => {
      const index = cat.dataset.index;
      const range = cat.dataset.range;
      let isActive = false;
      if (index !== undefined) {
        isActive = selectedIndex === parseInt(index);
      } else if (range) {
        const [min, max] = range.split('-').map(Number);
        isActive = selectedIndex >= min && selectedIndex <= max;
      }
      cat.classList.toggle('active', isActive);
    });

    const data = clarityGradeData[selectedIndex];
    document.getElementById('clarity-details').innerHTML = `
      <div class="de-details-header">
        <h3 class="de-details-title">${data.grade}</h3>
        <span style="font-size: 1.125rem; color: var(--de-stone-500);">${data.fullName}</span>
      </div>
      <p class="de-details-subtitle">${data.shortDesc}</p>
      <p class="de-details-description">${data.description}</p>
      <div class="de-characteristics">
        ${data.characteristics.map(c => `<div class="de-characteristic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg><span>${c}</span></div>`).join('')}
      </div>
      <div class="de-tip-box">
        <div class="de-tip-box-content">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
          <div><strong>Buying Tip: </strong><span>${data.buyingTip}</span></div>
        </div>
      </div>
      <div class="de-price-impact">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v18M5 8l7-5 7 5M5 16l7 5 7-5"/></svg>
        <span class="label">Price Impact:</span>
        <span class="value">${data.priceImpact}</span>
      </div>
    `;
  }

  function renderCaratSection(selectedIndex) {
    const scale = document.getElementById('carat-scale');
    const minSize = 28, maxSize = 95;
    const minDiam = 4.1, maxDiam = 9.3;

    scale.innerHTML = caratData.map((c, i) => {
      const norm = (c.diameter - minDiam) / (maxDiam - minDiam);
      const size = minSize + (norm * (maxSize - minSize));
      return `<div class="de-carat-diamond ${i === selectedIndex ? 'selected' : ''}" data-index="${i}">
        ${createCaratDiamondSVG(size, i === selectedIndex)}
        <span class="carat-label">${c.carat}ct</span>
        <span class="size-label">${c.diameter}mm</span>
        ${c.popular ? '<span class="popular-badge">Popular</span>' : ''}
      </div>`;
    }).join('');

    const data = caratData[selectedIndex];
    document.getElementById('carat-details').innerHTML = `
      <div class="de-carat-info">
        <div class="de-carat-value">
          <div class="number">${data.carat}</div>
          <div class="unit">Carats</div>
        </div>
        <div class="de-carat-divider"></div>
        <div class="de-carat-specs">
          <div class="de-carat-spec">
            <div class="label">Diameter</div>
            <div class="value">${data.diameter}mm</div>
          </div>
          <div class="de-carat-spec">
            <div class="label">Description</div>
            <div class="value">${data.description}</div>
          </div>
        </div>
      </div>
      <div class="de-carat-tip">
        <div class="de-tip-box">
          <div class="de-tip-box-content">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
            <div><strong>Pro Tip: </strong><span>A well-cut 0.90ct diamond can appear larger than a poorly-cut 1.00ct diamond. Prioritize cut quality over carat weight for maximum visual impact. Also consider "magic sizes" just under popular weights (0.95ct vs 1.00ct) for significant savings.</span></div>
          </div>
        </div>
      </div>
    `;
  }

  function renderSpecsSection(specKey) {
    const spec = specsData[specKey];
    document.getElementById('spec-content').innerHTML = `
      <div class="de-spec-header">
        <div class="de-spec-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            ${specKey === 'fluorescence' ? '<circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>' : ''}
            ${specKey === 'polish' ? '<path d="M12 3l1.5 4.5H18l-3.5 3 1.5 4.5L12 12l-4 3 1.5-4.5-3.5-3h4.5z"/>' : ''}
            ${specKey === 'symmetry' ? '<circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>' : ''}
          </svg>
        </div>
        <h3 class="de-spec-title">${spec.title}</h3>
      </div>
      <p class="de-spec-description">${spec.description}</p>
      <div class="de-spec-grades">
        ${spec.grades.map((g, i) => `
          <div class="de-spec-grade">
            <div class="de-spec-grade-header">
              <span class="de-spec-grade-name">${g.grade}</span>
              ${i === 0 ? '<span class="de-spec-recommended">Recommended</span>' : ''}
              <span class="de-spec-impact">${g.impact}</span>
            </div>
            <p class="de-spec-grade-desc">${g.desc}</p>
          </div>
        `).join('')}
      </div>
      <div class="de-tip-box" style="margin-top: 1.5rem;">
        <div class="de-tip-box-content">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
          <div><strong>Expert Tip: </strong><span>${spec.tip}</span></div>
        </div>
      </div>
    `;
  }

  // ============================================
  // EVENT HANDLERS
  // ============================================

  function initTabs() {
    const tabs = document.querySelectorAll('.de-tab');
    const sections = document.querySelectorAll('.de-section');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const tabId = tab.dataset.tab;

        tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');

        sections.forEach(s => s.classList.add('hidden'));
        document.getElementById(`${tabId}-section`).classList.remove('hidden');
      });
    });
  }

  function initCutSection() {
    let selectedIndex = 0;
    renderCutDetails(selectedIndex);

    document.getElementById('cut-grade-buttons').addEventListener('click', (e) => {
      const btn = e.target.closest('.de-grade-btn');
      if (!btn) return;

      selectedIndex = parseInt(btn.dataset.grade);
      document.querySelectorAll('#cut-grade-buttons .de-grade-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      renderCutDetails(selectedIndex);
    });
  }

  function initColorSection() {
    let selectedIndex = 3;
    renderColorSection(selectedIndex);

    document.getElementById('color-scale').addEventListener('click', (e) => {
      const diamond = e.target.closest('.de-color-diamond');
      if (!diamond) return;
      selectedIndex = parseInt(diamond.dataset.index);
      renderColorSection(selectedIndex);
    });
  }

  function initClaritySection() {
    let selectedIndex = 5;
    renderClaritySection(selectedIndex);

    document.getElementById('clarity-scale').addEventListener('click', (e) => {
      const diamond = e.target.closest('.de-clarity-diamond');
      if (!diamond) return;
      selectedIndex = parseInt(diamond.dataset.index);
      renderClaritySection(selectedIndex);
    });
  }

  function initCaratSection() {
    let selectedIndex = 3;
    renderCaratSection(selectedIndex);

    document.getElementById('carat-scale').addEventListener('click', (e) => {
      const diamond = e.target.closest('.de-carat-diamond');
      if (!diamond) return;
      selectedIndex = parseInt(diamond.dataset.index);
      renderCaratSection(selectedIndex);
    });
  }

  function initSpecsSection() {
    let activeSpec = 'fluorescence';
    renderSpecsSection(activeSpec);

    document.getElementById('spec-buttons').addEventListener('click', (e) => {
      const btn = e.target.closest('.de-spec-btn');
      if (!btn) return;

      activeSpec = btn.dataset.spec;
      document.querySelectorAll('.de-spec-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      renderSpecsSection(activeSpec);
    });
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  function init() {
    initTabs();
    initCutSection();
    initColorSection();
    initClaritySection();
    initCaratSection();
    initSpecsSection();
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
